export const YMAPS_TOKEN = '5a2eca2d-0356-4a63-8487-dc16f4334026';
